module.exports = __webpack_public_path__ + "img/mail_ellipse.ea022bc7.webp";